const ShipmentCategory = `
  id
  description
  updatedAt
`;

export default ShipmentCategory;
